import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'navaar-star-icon',
  template: ` <div class="check-your-rating-list">
                    <ng-template
                        ngFor
                        [ngForOf]="createRange()"
                        let-item
                        let-i="index"
                    >
                        <div
                            (click)="_rate(i)"
                            class="check-your-rating-star"
                            [class.disabled]="rateDisabled"
                            [class.active]="isActive(i)"
                        >
                            <svg
                                class="icon-svg-star"
                                viewBox="2421.167 403.5 24.13 23"
                                xmlns="http://www.w3.org/2000/svg"
                                [ngStyle]="_style"
                            >
                                <path
                                    class="a414"
                                    d="M2433.194 404l4.073 6.63 7.53 1.808-5.048 5.877.6 7.685-7.158-2.938-7.079 2.938.6-7.685-5.045-5.877 7.534-1.808z"
                                ></path>
                            </svg>
                        </div>
                    </ng-template>
                </div>`,
  styles: [`
  .check-your-rating-list {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: center;
    }
    .icon-svg-star {
      fill: transparent;
      stroke: #FFAD00;
      width: 100%;
      height: 100%;
      display: flex;
    }

    .check-your-rating-star {
      margin-right: 0;
    }
      .check-your-rating-star:last-of-type {
        margin-right: 0;
      }

      .check-your-rating-star.active  .icon-svg-star {
          stroke: none !important;
          fill: #FFAD00;
          stroke-width: none;
      }
      .disabled{
        pointer-events: none;
        opacity: .5;
      }`]
})
export class StarIconComponent  {

  @Input('star-is-disabled') public rateDisabled: boolean = false;
  @Input('rate-item') public rateItem: number;
  @Input('Id') public id: any;
  @Input('style') public _style: object | null;
  @Input('count-rating') public _rating: number = 5;
  @Output() private rate: EventEmitter<{ Id: any, index: number }> = new EventEmitter<{ Id: any, index: number }>();

  constructor() { }

  public _rate(index) {
    this.rate.emit({ Id: this.id, index: (index + 1) });
  }

  public createRange() {
    let items: number[] = [];
    for (let i = 1; i <= this._rating; i++) {
      items.push(i);
    }
    return items;
  }

  public isActive(i) {
    const _item = Math.floor(this.rateItem);
    return _item >= (i + 1);
  }
}
